export const client_id =
  '796758071306-vgnfjg3v13np23b6knjoirau10bkrfic.apps.googleusercontent.com';
export const client_secret = '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';
